import {PageResponse} from '../pageResponse';

export class CrashReport {
  id?: string;
  transactionId?: string;
  errorCode?: string;
  status?: string;
  category?: string;
  comment?: string;
  checksum?: string;
  contentSize?: string;
  creationDate?: string;
  updateDate?: string;
  updatedBy?: string;
  projectId?: string;
  projectName?: string;
  branchId?: string;
  branchName?: string;
  downloadable?: boolean;
  errorCodeToRender?: string;
  machineId?: string;
  noDumps?: boolean;
}


export class CrashReportResponse extends PageResponse {
  content: CrashReport[];
}

export class UpdateCrashReportRequest {
  constructor(public status: string,
              public updatedBy: string,
              public comment: string,
              public category: string,
              public machineId: string,
              public noDumps: boolean) {
  }
}

export enum CrashReportStatus {
  REVIEWED = 'Reviewed',
  NEW = 'New',
  PREPROCESSED = 'Preprocessed',
  SUSPICIOUS = 'Suspicious'
}
